import { render, staticRenderFns } from "./DialogPacks.vue?vue&type=template&id=db860afa&"
import script from "./DialogPacks.vue?vue&type=script&lang=js&"
export * from "./DialogPacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports